import React from "react";
import ClinicalReportSection from "./ClinicalReportSection";
import { opConsultConfig } from "./abhaClinicalConfigs";

const OPConsultSection = ({ patientId, patientData }) => (
  <ClinicalReportSection
    patientId={patientId}
    patientData={patientData}
    config={opConsultConfig}
  />
);

export default OPConsultSection;
